// @flow

import { logger } from '../common'

import { scriptParameters } from '../common/wizard'
import { defer } from '../common/defer'
import { updateSubscriberAttributesFromQueryParams } from '../common/updateSubscriberUsingQueryParams'
import { registerWizardEventListeners } from '../main/eventTracking'

import { createApp } from './app'
import { createStore } from './store'

function createWizardApp (store: any): void {
  window.ccWizardVueInstance = createApp(store)
}

function startupWizard (): void {
  logger.info('Starting up wizard...')
  window.ccWizardVueInstance = null

  const { customerId, subscriberId, parentUrl, wizardIntegrationId } = scriptParameters()

  if (!customerId) {
    // eslint-disable-next-line no-console
    console.warn('Chatchamp Wizard was not initialized properly.')
    return
  }

  const store = createStore(customerId, subscriberId, parentUrl, wizardIntegrationId)

  // TODO; Thiago; 14.07.2022; the following 2 lines is necessary because we are
  // using some components from chatbot (like ProductsItem).
  // After decoupling it we do not need them anymore.
  window.websocketReadyPromise = defer()
  window.bubbleStore = store

  function initWizard () {
    if (!window.ccWizardVueInstance) {
      registerWizardEventListeners()
      createWizardApp(store)
    }
  }

  initWizard()
  updateSubscriberAttributesFromQueryParams(customerId, subscriberId)
}

startupWizard()
